import { Button } from '@material-ui/core';
import { useEffect } from 'react';
import en from '../../../../lang/en-us';
import SuccessScreen from '../SuccessScreen';
const { dashboard } = en;

export default function MinorStatusSuccess(props: any) {
    const { reqId } = props.location.state || {};

    useEffect(() => {
        if (!props.location.state) {
            props.history.push('/');
        }
    }, []);

    return (
        <div className="curved-bg">
            <SuccessScreen
                heading={dashboard.MinorStatus.Success.back}
                backLink="nct/minor-status-review"
                info1={dashboard.MinorStatus.Success.subHeadingInfo1}
                infospan2={`${reqId}`}
                info3={dashboard.MinorStatus.Success.subHeadingInfo3}
                list={[]}
                handleClick={() => props.history.push('/portal/track')}
                backNavigation={() => props.history.goBack()}
            />
        </div>
    );
}
